import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import * as Utils from '_utils';
export function useServerData(url) {
    const [data, setData] = React.useState(null);
    React.useEffect(() => {
        async function fetchData() {
            try {
                setData({ state: 'loading' });
                const data = await Utils.Ajax.get(url) ?? null;
                setData(data);
            }
            catch (e) {
                console.error("Error fetching data from " + url, e);
                setData({ state: 'failed', error: e });
            }
        }
        fetchData();
    }, [url]);
    return data;
}
export function renderServerData(data, render) {
    if (data === null) {
        return _jsx(_Fragment, {});
    }
    if (data.state === 'loading') {
        return _jsx(Common.LoadingBar, {});
    }
    if (data.state === 'failed') {
        return (_jsx(Common.ErrorPanel, { title: "Unable to load data", children: data.error.toString() }));
    }
    return render(data);
}
